export const STORE_KEY = '$_classes';
